import { useEffect, useState } from "react";

export default function useFile() {
  const [file, setFile] = useState<File | null>(null);
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!file) {
      if (url) setUrl("");
      return;
    }
    setUrl(URL.createObjectURL(file));
  }, [file]);

  return { file, setFile, url, setUrl };
}
